import ShippingInfo from './ShippingInfo';

export default ShippingInfo;
